import { ProductList, ProductListCreate } from '@/models/ProductList';
import ProductListForm from '@/modules/product/components/ProductListForm';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon } from '@heroicons/react/24/outline';

const ProductListAdd = () => {
  const handleOnSubmit = (productList: ProductListCreate | ProductList): Promise<void> => {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        console.log(productList);
        resolve();
      }, 2000);
    });
  };

  return (
    <>
      <SettingsHeader
        title="Create Product List"
        icon={<RectangleStackIcon className="w-6 h-6" />}
      />

      <ProductListForm onSubmit={handleOnSubmit} />
    </>
  );
};

export default ProductListAdd;
